import { render } from "./SideCategoreis.vue?vue&type=template&id=49934702&scoped=true"
import script from "./SideCategoreis.vue?vue&type=script&lang=js"
export * from "./SideCategoreis.vue?vue&type=script&lang=js"

import "./SideCategoreis.vue?vue&type=style&index=0&id=49934702&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49934702"]])

export default __exports__